var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "shipping-group-total" },
    [
      _c("shipping-group-total-item", {
        staticClass: "shipping-group-total__header",
        attrs: { price: _vm.totalPrice },
        nativeOn: {
          click: function($event) {
            _vm.isExpanded = !_vm.isExpanded
          }
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function() {
              return [
                _c("checkout-label", {
                  staticClass: "shipping-group-total__order-label",
                  attrs: {
                    title: "Заказ " + (_vm.index + 1),
                    type: _vm.group.type
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "append",
            fn: function() {
              return [
                _c("chevron-animated", {
                  staticClass: "shipping-group-total__chevron",
                  attrs: { reverse: _vm.isExpanded }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.isExpanded
          ? _c(
              "div",
              { staticClass: "shipping-group-total__content" },
              [
                _vm.deliveryInfo
                  ? _c(
                      "div",
                      { staticClass: "shipping-group-total__delivery" },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.deliveryInfo.text))]),
                        _vm.deliveryInfo.date
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "shipping-group-total__delivery-date"
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.deliveryInfo.date) +
                                    "\n        "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _c("shipping-group-total-item", {
                  attrs: {
                    price: _vm.productsPrice - _vm.discount.total,
                    "old-price": _vm.productsPrice,
                    label: _vm.productAmountText
                  }
                }),
                _c("shipping-group-total-item", {
                  attrs: { price: _vm.shippingPrice, label: "Доставка" }
                }),
                _vm.discount.visible
                  ? _c("shipping-group-total-item", {
                      staticClass: "shipping-group-total__discount",
                      attrs: { price: -_vm.discount.visible, label: "Скидка" }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }